import { ServiceFrequency, SiteWarehouse } from "@gtpl/shared-models/common-models";
import { PoNumbersModel } from "@gtpl/shared-models/procurement-management";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsOptional, Matches, matches, MaxLength } from "class-validator";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import { ServiceStatusEnum } from "libs/shared-models/common-models/src/lib/enum/sevice-status.enum";



export class AssetsDto {

    @ApiProperty()
    assetId: number;

    @ApiProperty()
    @IsNotEmpty()
    assetsName: number;

    @ApiProperty()
    @IsNotEmpty()
    assetsCode: string;

    @ApiProperty()
    assetSerialNo: string;

    @ApiProperty()
    @IsNotEmpty()
    itemId: number;

    @ApiProperty()
    @IsNotEmpty()
    grnId: number;

    @ApiProperty()
    @IsNotEmpty()
    assetcondition: string;

    @ApiProperty()
    @IsNotEmpty()
    invoice: string;

    @ApiProperty()
    @IsNotEmpty()
    amc: string;

    @ApiProperty()
    amcStartDate: string;

    @ApiProperty()
    amcEndDate: string;

    @ApiProperty()
    amcProvider: string;

    @ApiProperty()
    @IsNotEmpty()
    amcname: string;

    @ApiProperty()
    @IsNotEmpty()
    amcno: string;

    @ApiProperty()
    @IsNotEmpty()
    noOfUnits: number;

    @ApiProperty()
    @IsNotEmpty()
    insurance: string;

    @ApiProperty()
    @IsNotEmpty()
    insuranceDate: any;

    @ApiProperty()
    @IsNotEmpty()
    manufacturer: string;

    @ApiProperty()
    @IsNotEmpty()
    model: string;

    @ApiProperty()
    @IsNotEmpty()
    year: any;

    @ApiProperty()
    assetSupplier: string;

    @ApiProperty()
    @IsNotEmpty()
    expiredDate: Date;

    @ApiProperty()
    @IsNotEmpty()
    assetCost: string;

    @ApiProperty()
    @IsNotEmpty()
    dateOfPurchased: Date;

    @ApiProperty()
    @IsNotEmpty()
    assetCategory: string;

    @ApiProperty()
    @IsNotEmpty()
    status: AssetStatusEnum;

    @ApiProperty()
    @IsNotEmpty()
    unitsOfMeasurements: string;


    @ApiProperty()
    @IsNotEmpty()
    currentLocation: number;

    currentLocationName?: string;

    @ApiProperty()
    @IsNotEmpty()
    lastCheckIn: Date;

    @ApiProperty()
    @IsOptional()
    lastCheckOut: Date;

    @ApiProperty()
    warrenty: string;

    @ApiProperty()
    warrentyExpiredDate: Date;

    @ApiProperty()
    ownerOfAsset: string;

    @ApiProperty()
    department: string;

    @ApiProperty()
    employeeId: number;

    @ApiProperty()
    amcReason: string;

    @ApiProperty()
    maintenanceDueDate: Date;

    @ApiProperty()
    transactionDate: Date;

    @ApiProperty()
    decommissionApprovedBy: string;

    @ApiProperty()
    serviceTenure: string;

    @ApiProperty()
    insuranceProvidedBy: string;

    @ApiProperty()
    plant: number;

    @ApiProperty()
    serviceStatus?: string;

    @ApiProperty()
    isActive: boolean;

    CreatedAt: Date;


    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: 'updated User allows maximum 40 charecters' })
    @Matches(new RegExp(""))
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: 'Updated User allows maximum 40 characters' })
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), { message: 'Updated User should be only alphabets' })
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    assetServiceDate: Date;

    @ApiProperty()
    serviceType: string;

    itemName?: string;
    employeeName?: string;
    employeePhNum?: string;
    assetID?: number;
    checkIn?: Date;
    dateDifference?: string;
    itemSubCategoryName: string;

    @ApiProperty()
    frequencyOfService: ServiceFrequency;
    @ApiProperty()
    month: string;

    @ApiProperty()
    day: string;

    @ApiProperty()
    assetRentTenureType: string;

    @ApiProperty()
    assetRentPeriod: string;

    @ApiProperty()
    rentalCostType: string;

    @ApiProperty()
    rentalCost: number;

    @ApiProperty()
    assetMode: string;

    @ApiProperty()
    assetType: string;

    @ApiProperty()
    insuranceRefNum: string;

    @ApiProperty()
    licenseNumber: string;

    @ApiProperty()
    softAssetManufacturer: string;

    @ApiProperty()
    hostingInfo: string;

    @ApiProperty()
    hostType: string;

    @ApiProperty()
    hostAddress: string;

    @ApiProperty()
    location: string;

    @ApiProperty()
    domainUrl: string;

    @ApiProperty()
    userName: string;

    @ApiProperty()
    password: string;

    @ApiProperty()
    state: string;

    @ApiProperty()
    host: string;

    @ApiProperty()
    provisionedSpace: string;

    @ApiProperty()
    usedSpace: string;

    @ApiProperty()
    compatibility: string;

    @ApiProperty()
    memorySize: string;

    @ApiProperty()
    cpu: string;

    @ApiProperty()
    nic: string;

    @ApiProperty()
    vmWareVersionToolStatus: string;

    @ApiProperty()
    alarmActions: string;
    
}